/**
 * EmployeeEmptyState Component
 * Displays empty state when no employees exist
 */
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { Users, Plus } from 'lucide-react';

const EmployeeEmptyState = ({ onAddClick }) => {
  return (
    <Card className="p-12" data-testid="employee-empty-state">
      <div className="flex flex-col items-center justify-center text-center">
        <Users className="w-16 h-16 text-slate-300 mb-4" />
        <h3 className="text-lg font-semibold text-slate-700 mb-2">
          Nenhum funcionário cadastrado
        </h3>
        <p className="text-slate-500 mb-4">
          Comece cadastrando seu primeiro funcionário ou importe uma planilha Excel.
        </p>
        <Button 
          onClick={onAddClick}
          className="bg-[#0d9488] hover:bg-[#0b7d73]"
        >
          <Plus className="w-4 h-4 mr-2" />
          Adicionar Funcionário
        </Button>
      </div>
    </Card>
  );
};

export default EmployeeEmptyState;
